// Charge l'exemple de démonstration (données fictives, marquées « Démo », supprimables en un geste).
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { FlaskConical } from 'lucide-react';
import { api, messageErreur } from '../lib/api.ts';
import { useSession } from '../lib/session.tsx';
import { Bouton, useNotifier } from './ui.tsx';

export function BoutonChargerDemo() {
  const { peut } = useSession();
  const [envoi, setEnvoi] = useState(false);
  const notifier = useNotifier();
  const qc = useQueryClient();
  const nav = useNavigate();
  if (!peut('dossier.ecrire')) return null;
  const charger = async () => {
    setEnvoi(true);
    try {
      const r = await api.post<{ dossierId: string }>('/api/demo/charger');
      await qc.invalidateQueries();
      notifier('Exemple de démonstration chargé (données fictives).');
      nav(`/etudes/${r.dossierId}`);
    } catch (e) {
      notifier(messageErreur(e), true);
    } finally {
      setEnvoi(false);
    }
  };
  return <Bouton icone={<FlaskConical aria-hidden />} chargement={envoi} onClick={charger}>Ouvrir l’exemple de démonstration</Bouton>;
}
